export default "__VITE_ASSET__Dxk7uMoy__"